import React from 'react';

import LoggedOutFilterPanel from '../FilterPanel/LoggedOutFilterPanel';
import LoggedOutFilterModal from './FilterModalComponent/LoggedOutFilterModal';

import './Filter.scss';

const LoggedOutFilter: React.FunctionComponent = () => {
    const [visible, setVisibility] = React.useState(false);
    const toggleVisibility = () => setVisibility((prevVisible) => !prevVisible);

    return (
        <div className="product-filter">
            <LoggedOutFilterPanel toggleVisibility={toggleVisibility} />
            <LoggedOutFilterModal visible={visible} toggleVisibility={toggleVisibility} />
        </div>
    );
};

export default LoggedOutFilter;
